import { Text } from '@zillow/constellation-10';

const WizardTipContent = (): JSX.Element => {
  return (
    <div data-testid="WizardTipContent">
      <Text css={{ marginBottom: '400' }} asChild>
        <p>More landlords who set screening criteria reported finding their renter on Zillow.</p>
      </Text>
      <Text textStyle="body-xs" css={{ color: 'text.subtle' }} asChild>
        <p>Source: Zillow internal data, Q1 2024</p>
      </Text>
    </div>
  );
};

export default WizardTipContent;
